import { createRouter, createWebHistory } from 'vue-router'
import About from '../components/About.vue'
import Dictionaries  from '../components/Dictionaries.vue'
import WebExplorer from '../components/WebExplorer.vue'
import Suggestions from '../components/Suggestions.vue'
import TranslationAssistant from '../components/TranslationAssistant.vue'
import UnivTermino from '../components/UnivTermino.vue'
const routes = [
  {
    path : "/univtermino",
    redirect : "/"
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/:lang?/:word?',
    name: 'UnivTermino',
    component: UnivTermino,
  },
  {
    path: '/webexplorer/:word?',
    name: 'WebExplorer',
    component: WebExplorer,
  },
  {
    path: '/dictionaries/:lang?/:word?',
    name: 'Dictionaries',
    component: Dictionaries,
  },
  {
    path: '/suggestions',
    name: 'Suggestions',
    component: Suggestions,
  },
  {
    path: '/translationassistant',
    name: 'TranslationAssistant',
    component: TranslationAssistant,
  },
  
]

const router = createRouter({
  mode : 'history',
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
